// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"772":"4ee5b13382406ae1","6898":"29a88270e77da1dd","6920":"02ee511a0832e4b7"}[chunkId] + ".js";
};